export default __webpack_public_path__ + "static/media/Shemite Mercenary Tunic.6674d7b7.jpg";